export enum Tipster {
  WITHOUT_TIPS = 'withoutTips',
  WITH_TIPS = 'withTips'
}
